import {
  InquiryFetchArgs,
  getInquiryDistinctValues,
} from '../../assets/ts/data/inquiry/inquiry'
import useServerData from '../use-server-data'

function useInquiryDistinctValues(
  fetchArgs: InquiryFetchArgs,
  waitOnParentDependency = false
) {
  const {
    data: inquiryDistinctValues,
    error: inquiryDistinctValuesError,
    fetchData: fetchInquiryDistinctValues,
    isLoading: inquiryDistinctValuesAreLoading,
  } = useServerData<Map<string, number[] | string[]>, InquiryFetchArgs>(
    getInquiryDistinctValues,
    fetchArgs,
    waitOnParentDependency
  )

  return {
    fetchInquiryDistinctValues,
    inquiryDistinctValues,
    inquiryDistinctValuesAreLoading,
    inquiryDistinctValuesError,
  }
}

export default useInquiryDistinctValues
